var _defs, _path, _polygon, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmergency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#128abc;stroke-linecap:round;stroke-linejoin:round;stroke-width:5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M163.31,140.28V167l50.61-38.47a61.77,61.77,0,1,0-68.76,4.86Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "207.08 70.21 187.11 70.21 187.11 50.24 166.7 50.24 166.7 70.21 146.74 70.21 146.74 90.62 166.7 90.62 166.7 110.58 187.11 110.58 187.11 90.62 207.08 90.62 207.08 70.21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M135.71,178.45s-4.33-6.06-12.82-3.55l-20.83,6.26S86.72,162.48,78.81,149h0a1.67,1.67,0,0,1-.12-.16,1.74,1.74,0,0,0-.11-.18h0c-9-12.77-19.65-34.47-19.65-34.47l14.3-16.39C79,91.14,75.3,84.68,75.3,84.68L61.41,49.41c-2.57-5.94-7.18-5.92-7.18-5.92-5.69-1-25.73,11.1-25.73,11.1-10.5,5.93-10,13.21-10,13.21C15.33,111,50.69,161,53.3,165.2c3.64,5.22,33.68,57,74.31,72,0,0,6.45,3.46,16.17-3.66,0,0,19.28-13.26,20.75-18.84,0,0,1.93-4.18-2.42-9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergency);
export default __webpack_public_path__ + "static/media/emergency.036041c8abca6ad619016ba609f9db01.svg";
export { ForwardRef as ReactComponent };